import PERFIL from '@/constants/perfil'

export const MENUS = {
  /* ARRECADACAO */
  [PERFIL.ARRECADACAO.GERENTE_GAT.codigo]: [
    {
      isItemMenu: true,
      nome: 'Cadastros',
      icon: 'fa-file-alt',
      routeName: 'gat/home',
      routeGroup: 'GAT_EM_ANALISE'
    },
    {
      isItemMenu: true,
      nome: 'Informações Solicitadas',
      icon: 'fa-info-circle',
      routeName: 'gat/informacoesSolicitadas',
      routeGroup: 'GAT_INFORMACOES_SOLICITADAS'
    }
  ],

  [PERFIL.ARRECADACAO.GERENTE_ARRECADACAO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Cadastros',
      icon: 'fa-file-alt',
      routeName: 'gat/home',
      routeGroup: 'GAT_EM_ANALISE'
    },
    {
      isItemMenu: true,
      nome: 'Informações Solicitadas',
      icon: 'fa-info-circle',
      routeName: 'gat/informacoesSolicitadas',
      routeGroup: 'GAT_INFORMACOES_SOLICITADAS'
    }
  ],

  [PERFIL.ARRECADACAO.COORDENADOR_CAF_ARRECADACAO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Caixa de entrada',
      icon: 'fa-envelope',
      routeName: 'caf/home',
      routeGroup: 'CAF_CAIXA_DE_ENTRADA'
    }
  ],

  [PERFIL.ARRECADACAO.PRESIDENTE_CPAT.codigo]: [
    {
      isItemMenu: true,
      nome: 'Caixa de entrada',
      icon: 'fa-envelope',
      routeName: 'cpat/home',
      routeGroup: 'CPAT_CAIXA_DE_ENTRADA'
    }
  ],

  [PERFIL.ARRECADACAO.ADMINISTRATIVO_S1_ARRECADACAO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Caixa de entrada',
      icon: 'fa-envelope',
      routeName: 'gp/home',
      routeGroup: 'GP_CAIXA_DE_ENTRADA'
    }
  ],

  [PERFIL.ARRECADACAO.PRESIDENTE_GP_ARRECADACAO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Caixa de entrada',
      icon: 'fa-envelope',
      routeName: 'gp/home',
      routeGroup: 'GP_CAIXA_DE_ENTRADA'
    }
  ],

  [PERFIL.ARRECADACAO.GERENTE_GDA_ARRECADACAO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Caixa de entrada',
      icon: 'fa-envelope',
      routeName: 'gda/home',
      routeGroup: 'GDA_CAIXA_DE_ENTRADA'
    }
  ],

  /* RECEPTOR */
  [PERFIL.RECEPTOR.RECEPTOR.codigo]: [
    {
      isItemMenu: true,
      nome: 'Baixar Módulo OFF-line',
      icon: 'fa-download',
      routeName: 'receptor/download',
      routeGroup: 'DOWNLOAD'
    },
    {
      isItemMenu: true,
      nome: 'Upload de cadastros',
      icon: 'fa-upload',
      routeName: 'receptor/upload',
      routeGroup: 'UPLOAD'
    },
    {
      isItemMenu: true,
      nome: 'Pendentes de Integração',
      icon: 'fa-sync',
      routeName: 'receptor/listagem-cadastros-pendentes',
      routeGroup: 'RECEPTOR_INFO_CADASTRO_PENDENTE',
      subMenu: [
        {
          nome: 'Detalhes do cadastro',
          routeName: 'informacoesCadastroPendente',
          icon: 'fa-sync',
          routeGroup: 'RECEPTOR_INFO_CADASTRO_PENDENTE',
          parentRouteGroup: 'LISTAGEM_CADASTROS_PENDENTES'
        }
      ]
    },
    {
      isItemMenu: true,
      nome: 'Processos',
      icon: 'fa-file-search',
      routeName: 'receptor/listagem',
      routeGroup: 'RECEPTOR_INFO_CADASTRO',
      subMenu: [
        {
          nome: 'Detalhes do processo',
          routeName: 'informacoesCadastroReceptor',
          icon: 'fa-file-chart-line',
          routeGroup: 'RECEPTOR_INFO_CADASTRO',
          parentRouteGroup: 'LISTAGEM'
        }
      ]
    }
  ],
  [PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Baixar Módulo OFF-line',
      icon: 'fa-download',
      routeName: 'receptor/download',
      routeGroup: 'DOWNLOAD'
    },
    {
      isItemMenu: true,
      nome: 'Upload de cadastros',
      icon: 'fa-upload',
      routeName: 'receptor/upload',
      routeGroup: 'UPLOAD'
    },
    {
      isItemMenu: true,
      nome: 'Pendentes de Integração',
      icon: 'fa-sync',
      routeName: 'receptor/listagem-cadastros-pendentes',
      routeGroup: 'RECEPTOR_INFO_CADASTRO_PENDENTE',
      subMenu: [
        {
          nome: 'Detalhes do cadastro',
          routeName: 'informacoesCadastroPendente',
          icon: 'fa-sync',
          routeGroup: 'RECEPTOR_INFO_CADASTRO_PENDENTE',
          parentRouteGroup: 'LISTAGEM_CADASTROS_PENDENTES'
        }
      ]
    },
    {
      isItemMenu: true,
      nome: 'Processos',
      icon: 'fa-file-search',
      routeName: 'receptor/listagem',
      routeGroup: 'RECEPTOR_INFO_CADASTRO',
      subMenu: [
        {
          nome: 'Detalhes do processo',
          routeName: 'informacoesCadastroReceptor',
          icon: 'fa-file-chart-line',
          routeGroup: 'RECEPTOR_INFO_CADASTRO',
          parentRouteGroup: 'LISTAGEM'
        }
      ]
    }
  ],

  /* FINANCEIRO */
  [PERFIL.FINANCEIRO.ANALISTA_COF.codigo]: [
    // {
    //   isItemMenu: true,
    //   nome: 'Processo físico',
    //   icon: 'fa-file-alt',
    //   routeName: 'cof/home',
    //   routeGroup: 'FINANCEIRO_CAIXA_DE_ENTRADA'
    // },
    {
      isItemMenu: true,
      nome: 'Relatórios',
      icon: 'fa-chart-bar',
      routeName: 'dae/relatorios',
      routeGroup: 'FINANCEIRO_RELATORIOS'
    },
    {
      isItemMenu: true,
      nome: 'Informações Solicitadas',
      icon: 'fa-info-circle',
      routeName: 'cof/informacoesSolicitadas',
      routeGroup: 'COF_INFORMACOES_SOLICITADAS'
    }
  ],

  [PERFIL.FINANCEIRO.COORDENADOR_COF.codigo]: [
    // {
    //   isItemMenu: true,
    //   nome: 'Processo físico',
    //   icon: 'fa-file-alt',
    //   routeName: 'cof/home',
    //   routeGroup: 'FINANCEIRO_CAIXA_DE_ENTRADA'
    // },
    {
      isItemMenu: true,
      nome: 'Relatórios',
      icon: 'fa-chart-bar',
      routeName: 'dae/relatorios',
      routeGroup: 'FINANCEIRO_RELATORIOS'
    },
    {
      isItemMenu: true,
      nome: 'Informações Solicitadas',
      icon: 'fa-info-circle',
      routeName: 'cof/informacoesSolicitadas',
      routeGroup: 'COF_INFORMACOES_SOLICITADAS'
    }
  ],

  [PERFIL.FINANCEIRO.FINANCEIRO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Processo físico',
      icon: 'fa-file-alt',
      routeName: 'cof/home',
      routeGroup: 'FINANCEIRO_CAIXA_DE_ENTRADA'
    },
    {
      isItemMenu: true,
      nome: 'Relatórios',
      icon: 'fa-chart-bar',
      routeName: 'dae/relatorios',
      routeGroup: 'FINANCEIRO_RELATORIOS'
    },
    {
      isItemMenu: true,
      nome: 'Informações Solicitadas',
      icon: 'fa-info-circle',
      routeName: 'cof/informacoesSolicitadas',
      routeGroup: 'COF_INFORMACOES_SOLICITADAS'
    }
  ],

  /* CENTRAL */
  [PERFIL.CENTRAL_DO_INTERESSADO.EXTERNO.codigo]: [
    {
      isItemMenu: true,
      nome: 'Consultar processos existentes',
      icon: 'fa-file-search',
      routeName: 'central/processos',
      routeGroup: 'CENTRAL_PROCESSOS',

      subMenu: [
        {
          nome: 'Detalhes do processo',
          routeName: 'informacoesCadastro',
          icon: 'fa-file-chart-line',
          routeGroup: 'CENTRAL_INFO_CADASTRO',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Central de mensagens',
          routeName: 'caixa-entrada',
          icon: 'fa-envelope',
          routeGroup: 'CENTRAL_MENSAGENS',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Gerenciamento de DAEs',
          routeName: 'gerenciamento-daes',
          icon: 'fa-dollar-sign',
          routeGroup: 'CENTRAL_DAES',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        }
      ],

      // Atributos para menu por cards
      codigo: 'PROCESSOS_EXISTENTES',
      img: 'processosExistentes.png'
    }
    // {
    //   isItemMenu: true,
    //   nome: 'Solicitar Informação',
    //   icon: 'fa-info-circle',
    //   routeName: 'listagem/informacoes',
    //   routeGroup: 'CENTRAL_SOLICITAR_INFORMACOES',

    //   // Atributos para menu por cards
    //   codigo: 'SOLICITAR_INFORMACAO',
    //   img: 'informacao.png'
    // },
    // {
    //   isItemMenu: true,
    //   nome: 'Solicitar Permuta',
    //   icon: 'fa-file-check',
    //   routeName: 'listagem/permuta',
    //   routeGroup: 'CENTRAL_PERMUTA',

    //   // Atributos para menu por cards
    //   codigo: 'PERMUTA',
    //   img: 'permuta.png'
    // }
  ],

  [PERFIL.CENTRAL_DO_INTERESSADO.PREFEITURA.codigo]: [
    {
      isItemMenu: true,
      nome: 'Consultar processos existentes',
      icon: 'fa-file-search',
      routeName: 'central/processos',
      routeGroup: 'CENTRAL_PROCESSOS',

      subMenu: [
        {
          nome: 'Detalhes do processo',
          routeName: 'informacoesCadastro',
          icon: 'fa-file-chart-line',
          routeGroup: 'CENTRAL_INFO_CADASTRO',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Central de mensagens',
          routeName: 'caixa-entrada',
          icon: 'fa-envelope',
          routeGroup: 'CENTRAL_MENSAGENS',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        },
        {
          nome: 'Gerenciamento de DAEs',
          routeName: 'gerenciamento-daes',
          icon: 'fa-dollar-sign',
          routeGroup: 'CENTRAL_DAES',
          parentRouteGroup: 'CENTRAL_PROCESSOS'
        }
      ],

      // Atributos para menu por cards
      codigo: 'PROCESSOS_EXISTENTES',
      img: 'processosExistentes.png'
    },
    {
      isItemMenu: true,
      nome: 'Solicitar informação',
      icon: 'fa-info-circle',
      routeName: 'listagem/informacoes',
      routeGroup: 'CENTRAL_SOLICITAR_INFORMACOES',

      // Atributos para menu por cards
      codigo: 'SOLICITAR_INFORMACAO',
      img: 'informacao.png'
    },
    {
      isItemMenu: true,
      nome: 'Solicitar regularização de áreas patrimoniais',
      icon: 'fa-file-times',
      routeName: 'listagem/areasPatrimoniais',
      routeGroup: 'CENTRAL_AREAS_PATRIMONIAIS',

      // Atributos para menu por cards
      codigo: 'PREFEITURA',
      img: 'areasPatrimoniais.png'
    }
  ],

  /* ASSINATURA */
  [PERFIL.ASSINATURA.ASSINADOR.codigo]: [
    {
      isItemMenu: true,
      nome: 'Caixa de entrada',
      icon: 'fa-envelope',
      routeName: 'assinatura/home',
      routeGroup: 'ASSINATURA_CAIXA_DE_ENTRADA'
    },
    {
      isItemMenu: true,
      nome: 'Documentos assinados',
      icon: 'fa-pen',
      routeName: 'assinatura/documentosAssinados',
      routeGroup: 'ASSINATURA_DOCUMENTOS_ASSINADOS'
    }
  ],

  /* GESTÃO DE DEMANDAS */
  [PERFIL.GESTAO_DE_DEMANDAS.GESTOR_DE_DEMANDAS.codigo]: [
    {
      isItemMenu: true,
      nome: 'Demandas',
      icon: 'fa-table',
      routeName: 'demandas/home',
      routeGroup: 'GESTAO_DE_DEMANDAS'
    },
    {
      isItemMenu: true,
      nome: 'Relatórios',
      icon: 'far fa-analytics',
      routeName: 'demandas/relatorios',
      routeGroup: 'GESTAO_DE_DEMANDAS_RELATORIOS'
    }

  ],

  /* RELATORIOS */
  [PERFIL.RELATORIOS.RELATORIOS.codigo]: [
    {
      isItemMenu: true,
      nome: 'Relatórios Gerais',
      icon: 'fa-file-alt',
      routeName: 'relatorios/gerais',
      routeGroup: 'RELATORIOS',

      // Atributos para menu por cards
      codigo: 'RELATORIOS',
      img: 'RelatorioGeral.png'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/constants/ba/menu.js